import styled from 'styled-components'

interface IWidthProp {
  width?: number
}
export const DropdownCard = styled.div<IWidthProp>`
  padding: ${props => props.theme.spacings[24]}px;
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.neutral.level5};
  border-radius: ${props => props.theme.radii[12]}px;
  display: flex;
  flex-direction: column;
  ${props => props.width && `width: ${props.width}px;`}
`

export const RightAlignedFlexRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const ApplyButtonContainer = styled.div`
  width: 106px;
`
